import VisibilityOffRounded from "@mui/icons-material/VisibilityOffRounded";

export const visibilityOff = ({ size = 15, color = "white" }) => {
  return <VisibilityOffRounded />;
};
